export function initialize(units) {

    let graphs = document.querySelectorAll('[data-counter]');

    graphs.forEach(function(target) {
        let max = target.getAttribute('data-counter')*1;
        let step = max / 250;
        let interval = 10;

        if(step < 1) {
            interval = Math.floor(2500 / max);
            step = 1;
        }

        let counter = 0;
        let intervalCb = setInterval(function() {
            if(counter > max) {
                displayValue(target, max, units);
                clearInterval(intervalCb);
                return;
            }
            counter += step;
            displayValue(target, counter);
        }, interval);
    });
}

function displayValue(element, value, units)
{
    if(typeof units === 'undefined') {
        units = {
            'mil': 'mil.',
            'tis': 'tis.'
        };
    }

    if(value > 1000000) {
        let v = ((Math.round(value/100000)/10)+'').replace('.', ',');
        element.innerHTML = (v.indexOf(',') >= 0 ? v : (v+',0')) + ' <small>' + units.mil + '</small>';
    } else if(value > 10000) {
        element.innerHTML = (Math.round(value/10000)+'').replace('.', ',') + ' <small>' + units.tis + '</small>';
    } else {
        element.innerHTML = Math.round(value);
    }
}

export default {

};
